import React, { Component } from 'react';
import mirrorTipImg from '../../Login/Login/images/mirror_tip_img@2x.png'

class BsyMirrorTip extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showTip: React.cookie.load('mirrorIsOpen') === "yes" || !React.cookie.load('mirrorIsOnce'),
            isOnce: !React.cookie.load('mirrorIsOnce'),
        };
        this.mirrorCont = React.createRef();
    }
    isTouch = false;
    componentDidMount() {
        let mirrorTop = React.cookie.load("mirrorTop");
        if(!React.cookie.load("bby_mirror_access")){
            return;
        }

        this.mirrorCont && this.mirrorCont.current && this.mirrorCont.current.addEventListener('mousedown', this.onTouchDown)
        if(!mirrorTop){
            this.mirrorCont && this.mirrorCont.current && (this.mirrorCont.current.style.transform = "translate(0, "+document.body.offsetHeight - this.mirrorCont.current.offsetHeight+"px)");
        }else{
            this.mirrorCont && this.mirrorCont.current && (this.mirrorCont.current.style.transform = "translate(0, "+mirrorTop+"px)");
        }
        
    }

    componentWillUnmount(){
        console.log("componentWillUnmount")
    }

    onTouchMouseUp =(event) => {
        event.preventDefault();
        event.stopPropagation();
        document.removeEventListener('mousemove', this.onTouchMove);
        document.removeEventListener('mouseup', this.onTouchMouseUp);
        this.isTouch = false;
    }
    ele_y = 0;
    max_top = 0;
    onTouchDown = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        this.max_top = document.body.offsetHeight - this.mirrorCont.current.offsetHeight;
        if (!this.state.isOnce) {
            this.isTouch = true;
            this.ele_y = event.offsetY;
            document.addEventListener('mousemove', this.onTouchMove);
            document.addEventListener('mouseup', this.onTouchMouseUp);
        }
    }

    onTouchMove = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let top = e.clientY - this.ele_y;
        top = top < 0 ? 0 : top;
        top = top > this.max_top ? this.max_top : top;
        this.mirrorCont.current.style.transform = "translate(0, "+top+"px)";
        this.mirrorCont.current.style.bottom = "auto";
        window.FX.Cookie.set("mirrorTop", top, {path:"/"});
    }

    changeTip = (event) => {
        event.stopPropagation()
        const { showTip, isOnce } = this.state;
        if (!this.isTouch) {
            if (!isOnce) {
                window.FX.Cookie.set('mirrorIsOpen', showTip ? "no" : "yes", { path: "/" })
                this.setState({
                    showTip: !showTip,
                });
            }
        }
    }
    closeTip = () => {
        setTimeout(() => {
            React.cookie.save('mirrorIsOnce', true, { path: "/" })
            this.setState({
                showTip: false,
                isOnce: false
            });
        })
    }
    render() {
        const { showTip, isOnce } = this.state;
        let timeCookie = Number(React.cookie.load("bby_mirror_access")) * 1000;
        let mirrorTop = React.cookie.load("mirrorTop");
        let year = new Date(timeCookie).getFullYear();
        let month = new Date(timeCookie).getMonth() + 1;
        if (month <= 9) {
            month = "0" + month;
        }
        let day = new Date(timeCookie).getDate();
        if (day <= 9) {
            day = "0" + day;
        }
        let hour = new Date(timeCookie).getHours();
        if (hour <= 9) {
            hour = "0" + hour;
        }
        let minutes = new Date(timeCookie).getMinutes();
        if (minutes <= 9) {
            minutes = "0" + minutes;
        }
        let seconds = new Date(timeCookie).getSeconds();
        if (seconds <= 9) {
            seconds = "0" + seconds;
        }
        let time = year + "." + month + "." + day + " " + hour + ":" + minutes + ":" + seconds;
        return (
            <>
                {React.cookie.load("bby_mirror_access") && <div className={"mirrorTip" + (isOnce ? " isOnce" : "")}>
                    <div className={"mirrorCont"} style={{ transform: "translate(0, "+mirrorTop+"px)",bottom:mirrorTop?"auto":"",top:mirrorTop?"0":""}} ref={this.mirrorCont}>
                        <div className={"mirrorTipContent" + (showTip ? " showTip" : "")} onClick={this.changeTip}>
                            <div className="mirrorTipImg">
                                <img src={mirrorTipImg} alt="" />
                            </div>
                            {showTip && <span>{React.language('login.mirror.system.tip.title', { time })}</span>}
                        </div>
                        {isOnce && <div className="mirrorContTip">
                            <span>{React.language('login.mirror.access.msg')}</span>
                            <i className="icon-bsy-close-small" onClick={this.closeTip}></i>
                        </div>}
                    </div>
                </div>}
            </>
        );
    }
}

export default BsyMirrorTip;
